// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"134":"74c7a436","679":"21baecad"}[chunkId] + ".css";
};